<template>
    <div>
        <div class="loader-wrapper" :class="{ 'loader-wrapper--luxliebe': isLuxliebe }" v-show="display">
            <slot></slot>
            <div class="circle circle-1"></div>
            <div class="circle circle-2"></div>
            <div class="circle circle-3"></div>
            <div class="circle circle-4"></div>
            <div class="circle circle-5"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContentLoader",
    props: {
        wait: {
            type: Number,
            default: 500
        }
    },
    data() {
        return {
            display: false,
            timeout: null,
            isLuxliebe: process.env.VUE_APP_THEME === 'luxliebe'
        }
    },
    mounted() {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => this.display = true, this.wait)
    }
}
</script>


<style scoped lang="scss">
    $color: #BFA46A, #8F7B50, #605235, #30291B, #000000;
    $circle-size: 16px;
    $circle-margin: 7px;

    .loader-wrapper {
        width: 100%;
        height: 100%;
        position: relative;
        min-height: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .circle {
    width: $circle-size;
    height: $circle-size;
    border-radius: 50%;
    margin: $circle-margin;
    display: flex;
    justify-content: center;
    align-items: center;

        &:before {
            content: "";
            width: $circle-size;
            height: $circle-size;
            border-radius: 50%;
            opacity: 0.7;
            animation: scale 1.8s infinite
            cubic-bezier(0, 0, 0.49, 1.02);
        }
    }

    @for $i from 1 through 5 {
        .circle-#{$i} {
            background-color: nth($color, $i);
            &:before {
            background-color: nth($color, $i);
            animation-delay: 200ms * $i;
            }
        }
    }

    .loader-wrapper--luxliebe {
        .circle-1,
        .circle-1:before {
            background-color: #f5d6e5;
        }

        .circle-2,
        .circle-2:before {
            background-color: #FF6B9D;
        }

        .circle-3,
        .circle-3:before {
            background-color: #E8187A;
        }

        .circle-4,
        .circle-4:before {
            background-color: #8A1060;
        }

        .circle-5,
        .circle-5:before {
            background-color: #130A0E;
        }
    }

    @keyframes scale {
        0% {
            transform: scale(1);
        }
        50%, 75% {
            transform: scale(2.5);
        }
        78%, 100% {
            opacity: 0;
        }
    }


</style>
